export enum ThemeStyle {
  MODERN = 'modern',
  STANDARD = 'standard',
}
export enum ThemeStyleRadius {
  MODERN = '8x',
  STANDARD = '6px',
}
export enum ThemeMode {
  LIGHT = 'light',
  SEMI_DARK = 'semi-dark',
  DARK = 'dark',
}
export enum LayoutType {
  FULL_WIDTH = 'full-width',
  BOXED = 'boxed',
  FRAMED = 'framed',
}

export enum MenuStyle {
  DEFAULT = 'default',
  STANDARD = 'standard',
  ROUNDED = 'rounded',
  ROUNDED_REVERSE = 'rounded-reverse',
  CURVED_MENU = 'curved-menu',
}

export enum NavStyle {
  DEFAULT = 'default',
  MINI = 'mini',
  MINI_SIDEBAR_TOGGLE = 'mini-sidebar-toggle',
  STANDARD = 'standard',
  HEADER_USER = 'user-header',
  HEADER_USER_MINI = 'user-mini-header',
  DRAWER = 'drawer',
  BIT_BUCKET = 'bit-bucket',
  H_DEFAULT = 'h-default',
  HOR_HEADER_FIXED = 'hor-header-fixed',
  HOR_DARK_LAYOUT = 'hor-dark-layout',
}
export enum FooterType {
  FIXED = 'fixed',
  FLUID = 'fluid',
}
export enum LayoutDirection {
  RTL = 'rtl',
  LTR = 'ltr',
}
export enum HeaderType {
  DARK = 'dark',
  LIGHT = 'light',
}
export enum RouteTransition {
  NONE = 'none',
  FADE = 'fade',
  SLIDE_LEFT = 'slideLeft',
  SLIDE_RIGHT = 'slideRight',
  SLIDE_UP = 'slideUp',
  SLIDE_DOWN = 'slideDown',
}
export enum Fonts {
  LIGHT = '300',
  REGULAR = '400',
  MEDIUM = '500',
  BOLD = '600',
}

export enum AuthType {
  AWS_COGNITO = 'aws_cognito',
  AUTH0 = 'auth0',
  JWT_AUTH = 'jwt_auth',
}

export enum AppAnimates {
  SLIDEUPIN = 'transition.slideUpIn',
  SLIDEUPOUT = 'transition.slideUpOut',
  SLIDEDOWNIN = 'transition.slideDownIn',
  SLIDEDOWNOUT = 'transition.slideDownOut',
  SLIDELEFTIN = 'transition.slideLeftIn',
  SLIDELEFTOUT = 'transition.slideLeftOut',
  SLIDERIGHTIN = 'transition.slideRightIn',
  SLIDERIGHTOUT = 'transition.slideRightOut',
  FADEIN = 'transition.fadeIn',
  FADEOUT = 'transition.fadeOut',
}

export const AppAnimateGroups = {
  SLIDEUPIN: {
    hidden: {
      y: 0,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        ease: 'easeIn',
        delay: 0,
        when: 'beforeChildren',
        duration: 0.2,
        staggerChildren: 0.05,
      },
    },
  },
  SLIDEUPOUT: {
    hidden: {
      y: 0,
    },
    visible: {
      opacity: 0,
      y: '100vh',
      transition: {
        ease: 'easeOut',
        delay: 0,
        when: 'beforeChildren',
        duration: 0.4,
        staggerChildren: 0.15,
      },
    },
  },
  SLIDEDOWNIN: {
    hidden: {
      opacity: 0,
      y: '-100vh',
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        ease: 'easeIn',
        delay: 0,
        when: 'beforeChildren',
        duration: 0.4,
        staggerChildren: 0.15,
      },
    },
  },
  SLIDEDOWNOUT: {
    hidden: {
      y: 0,
    },
    visible: {
      opacity: 0,
      y: '-100vh',
      transition: {
        ease: 'easeOut',
        delay: 0,
        when: 'beforeChildren',
        duration: 0.4,
        staggerChildren: 0.15,
      },
    },
  },
  SLIDELEFTIN: {
    hidden: {
      x: '100vw',
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        ease: 'easeIn',
        delay: 0,
        when: 'beforeChildren',
        duration: 0.4,
        staggerChildren: 0.15,
      },
    },
  },
  SLIDELEFTOUT: {
    hidden: {
      x: 0,
    },
    visible: {
      opacity: 0,
      x: '100vw',
      transition: {
        ease: 'easeOut',
        delay: 0,
        when: 'beforeChildren',
        duration: 0.4,
        staggerChildren: 0.15,
      },
    },
  },
  SLIDERIGHTIN: {
    hidden: {
      x: '-100vw',
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        ease: 'easeIn',
        delay: 0,
        when: 'beforeChildren',
        duration: 0.4,
        staggerChildren: 0.15,
      },
    },
  },
  SLIDERIGHTOUT: {
    hidden: {
      x: 0,
    },
    visible: {
      opacity: 0,
      x: '-100vw',
      transition: {
        ease: 'easeOut',
        delay: 0,
        when: 'beforeChildren',
        duration: 0.4,
        staggerChildren: 0.15,
      },
    },
  },
  FADEIN: {
    hidden: {
      opacity: 0,
      scale: 1,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        ease: 'easeIn',
        when: 'beforeChildren',
        staggerChildren: 0.15,
      },
    },
  },
  FADEOUT: {
    hidden: {
      opacity: 1,
      scale: 1,
    },
    visible: {
      opacity: 0,
      scale: 1,
      transition: {
        ease: 'easeOut',
        when: 'beforeChildren',
        staggerChildren: 0.15,
      },
    },
  },
  NOANIMATION: {
    hidden: {
      opacity: 1,
    },
    visible: {
      opacity: 1,
    },
  },
};

export const AppMotionAnimate = {
  SLIDEUPIN: {
    variants: {
      hidden: {
        y: 100,
        opacity: 0,
      },
      visible: {
        opacity: 1,
        y: 0,
      },
    },
    transition: {
      ease: 'easeIn',
      when: 'beforeChildren',
    },
  },
  SLIDEUPOUT: {
    variants: {
      hidden: {
        y: 0,
        opacity: 1,
      },
      visible: {
        opacity: 0,
        y: '-100vh',
      },
    },
    transition: {
      ease: 'easeOut',
      when: 'beforeChildren',
    },
  },
  SLIDEDOWNIN: {
    variants: {
      hidden: {
        y: -100,
        opacity: 0,
      },
      visible: {
        opacity: 1,
        y: 0,
      },
    },
    transition: {
      ease: 'easeIn',
      when: 'beforeChildren',
    },
  },
  SLIDEDOWNOUT: {
    variants: {
      hidden: {
        y: 0,
        opacity: 1,
      },
      visible: {
        opacity: 0,
        y: '100vh',
      },
    },
    transition: {
      ease: 'easeOut',
      when: 'beforeChildren',
    },
  },
  SLIDELEFTIN: {
    variants: {
      hidden: {
        x: 100,
        opacity: 0,
      },
      visible: {
        opacity: 1,
        x: 0,
      },
    },
    transition: {
      ease: 'easeIn',
      when: 'beforeChildren',
    },
  },
  SLIDELEFTOUT: {
    variants: {
      hidden: {
        x: 0,
        opacity: 1,
      },
      visible: {
        opacity: 0,
        x: '-100vw',
      },
    },
    transition: {
      ease: 'easeOut',
      when: 'beforeChildren',
    },
  },
  SLIDERIGHTIN: {
    variants: {
      hidden: {
        x: -100,
        opacity: 0,
      },
      visible: {
        opacity: 1,
        x: 0,
      },
    },
    transition: {
      ease: 'easeIn',
      when: 'beforeChildren',
    },
  },
  SLIDERIGHTOUT: {
    variants: {
      hidden: {
        x: 0,
        opacity: 1,
      },
      visible: {
        opacity: 0,
        x: '-100vw',
      },
    },
    transition: {
      ease: 'easeOut',
      when: 'beforeChildren',
    },
  },
  FADEIN: {
    variants: {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
      },
    },
    transition: {
      duration: 0.1,
      ease: 'easeIn',
      when: 'beforeChildren',
    },
  },
  FADEOUT: {
    variants: {
      hidden: {
        opacity: 1,
      },
      visible: {
        opacity: 0,
      },
    },
    transition: {
      duration: 0.1,
      ease: 'easeOut',
      when: 'beforeChildren',
    },
  },
};

export enum MessageType {
  MEDIA = 1,
  TEXT = 2,
}


export enum OnboardingTaskStatusEnum {
  NA = 'N/A',
  NO = 'NO',
  YES = 'YES',
}

export enum VerifiedIdOrCodeStatusEnum {
  DONE = 'DONE',
  PENDING = 'PENDING',
}

export enum RegistrationStatusOnboardingEnum {
  PENDING = 'PENDING',
  PART_REGISTERED = 'PART_REGISTERED',
  REGISTRATION_COMPLETE = 'REGISTRATION_COMPLETE',
}

export enum OnboardingStep {
  ADD_NATIONALITY = 'addNationality',
  ADD_ID = 'addID',
  ADD_SHARE_CODE = 'addShareCode',
  ADD_DOB = 'addDOB',
  ADD_BANK_DETAILS = 'addBankDetails',
  ADD_ADDRESS_DETAILS = 'addAddressDetails',
  ADD_JOB_DESCRIPTION = 'addJobDescription',
  ADD_WORKING_TIME_REGULATION = 'addWorkingTimeRegulation',
  ADD_AGENCY_CONDUCT_REGULATION = 'addAgencyConductRegulation',
  ADD_P45_STARTER_DECLARATION = 'addP45StarterDeclaration',
  ADD_P45_DETAILS = 'addP45Details',
  ADD_NI_NUMBER = 'addNINumber',
  ADD_HOLIDAY_PAY_METHOD = 'addHolidayPayMethod',
  ADD_UTR = 'addUTR',
  ADD_SIGN_CONTRACT = 'signContract',
  ADD_CAPTURE_ID_DOCS = 'addCaptureIdDocs',
}

export enum PaymentSettingType {
  PAYMENT = 'PAYMENT',
  DEDUCTION = 'DEDUCTION',
  PAYMENT_RATE = 'PAYMENT_RATE',
  VAT_CODES = 'VAT_CODES',
}

export enum StatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum InvoiceTypeEnum {
  INVOICE = 'INVOICE',
  CREDIT_NOTE = 'CREDIT_NOTE',
}

export enum InvoiceSystemTypeEnum {
  DEFAULT = 'DEFAULT',
  ER_COST = 'ER_COST',
}

export enum InvoiceStatus {
  INVOICED = 'INVOICED',
  CREDITED = 'CREDITED',
  OUTSTANDING = 'OUTSTANDING',
  PAID = 'PAID',
  ALL = 'ALL',
}

export enum PayrollFeeMethodEnum {
  FIXED_FEE_PER_EMPLOYEE = 'FIXED_FEE_PER_EMPLOYEE',
  TIERED_FEE = 'TIERED_FEE',
}

export enum RaiseInvoiceMethodEnum {
  DETAILED = 'DETAILED',
  SUMMARY = 'SUMMARY',
}

export enum TimesheetStatusEnum {
  AWAITING_APPROVAL = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  CANCEL = 'CANCEL',
  INACTIVE = 'INACTIVE',
}

export enum TimesheetApproveStatusEnum {
  PENDING = 'PENDING',
}

export enum InvoiceStatusEnum {
  AWAITING_INVOICING = 'AWAITING_INVOICING',
  AWAITING_DRAFT = 'AWAITING_DRAFT',
}

export enum HolidayMethodEnum {
  RETAINED = 'RETAINED',
  ROLLED_UP = 'ROLLED_UP',
  FIFTY_TWO_WEEK_AVERAGE = 'FIFTY_TWO_WEEK_AVERAGE',
  NO_HOLIDAY_PAY = 'NO_HOLIDAY_PAY',
}

export enum AccrueHolidayPayEnum {
  AMOUNT = 'AMOUNT',
  AVG_HOURLY_RATE = 'AVG_HOURLY_RATE',
}

export enum AgencyInvoiceMethodEnum {
  ONE_PER_TIMESHEET = 'ONE_PER_TIMESHEET',
  CONSOLIDATE_BY_TIMESHEET_BATCH = 'CONSOLIDATE_BY_TIMESHEET_BATCH',
  BY_SITE = 'BY_SITE',
}

export enum PaymentFrequencyEnum {
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  FOUR_WEEKLY = '4_WEEKLY',
  TWO_WEEKLY = '2_WEEKLY',
}

export const enumMarginMethod = {
  FIXED_FEE: 'FIXED_FEE',
  FIXED_FEE_TABLE: 'FIXED_FEE_TABLE',
  PERCENT_TABLE_ON_TIMESHEET_VALUE: '%_TABLE_ON_TIMESHEET_VALUE',
  PERCENT_ON_TIMESHEET_VALUE: '%_ON_TIMESHEET_VALUE',
  NONE: 'NONE',
};

export enum AgencyTimesheetValueAccessEnum {
  AMOUNT = 'AMOUNT',
  PERCENT = 'PERCENT',
}

export enum InvoiceMethodEnum {
  TIERED_FEE = 'TIERED_FEE',
  FIXED_FEE_PER_EMPLOYEE = 'FIXED_FEE_PER_EMPLOYEE',
}

export enum YesNoNAEnum {
  YES = 'TRUE',
  NO = 'FALSE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export enum LoanTypesEnum {
  PLAN_1 = 'ST_PLAN_1',
  PLAN_2 = 'ST_PLAN_2',
  PLAN_4 = 'ST_PLAN_4',
  PLAN_5 = 'ST_PLAN_5',
  PGL = 'PGL',
}

export enum BusinessTypeEnum {
  SOLE_TRADER = 'SOLE_TRADER',
  COMPANY = 'COMPANY',
  PARTNERSHIP = 'PARTNERSHIP',
}

export enum PAYMENT_MODEL_ENUM {
  UMBRELLA = 'UMBRELLA',
  PAYEE = 'PAYEE',
  HYBRID = 'HYBRID',
  PAYE_HYBRID = 'PAYE_HYBRID',
  PAYE_FTH = 'PAYE_FTH',
  CIS = 'CIS',
  NON_CIS = 'NON_CIS',
}

export enum ExpenseTypeEnum {
  MILEAGE = 'MILEAGE',
  OTHER = 'OTHER',
}

export enum ContractDetailTypeEnum {
  NEW_EMPLOYEE = 'NEW_EMPLOYEE',
  EXISTING_EMPLOYEE = 'EXISTING_EMPLOYEE',
}

export enum EmploymentStatusEnum {
  EMPLOYEE = 'EMPLOYEE',
  DIRECTOR = 'DIRECTOR',
  WORKER = 'WORKER',
  OFF_PAYROLL = 'OFF_PAYROLL_WORKER',
}

export enum VehicleTypeEnum {
  CAR = 'CAR',
  VAN = 'VAN',
}

export enum LoanTypeEnum {
  QUALIFYING_HOME_LOAN = 'QUALIFYING_HOME_LOAN',
  OTHER_LOAN = 'OTHER_LOAN',
}

export enum MedicalInsuranceTypeEnum {
  ANNUAL = 'MEDICAL_INSURANCE_ANNUAL',
  ONE_OFF = 'MEDICAL_INSURANCE_ONE_OFF',
}

export enum EeErPensionMethodEnum {
  PERCENTAGE = 'PERCENTAGE',
  AMOUNT = 'AMOUNT',
}

export enum PensionProvidersNameEnum {
  NOW_PENSIONS = 'NOW_PENSIONS',
  SMART_PENSION = 'SMART_PENSION',
  NEST_PENSION = 'NEST_PENSION',
  JARVIS_PENSION = 'JARVIS_PENSION',
  AVIVA = 'AVIVA',
  AEGON = 'AEGON',
  PEOPLES_PENSION = 'PEOPLES_PENSION',
  ROYAL_LONDON = 'ROYAL_LONDON',
  SCOTTISH_WIDOWS = 'SCOTTISH_WIDOWS',
  STANDARD_LIFE = 'STANDARD_LIFE',
  PENFOLD = 'PENFOLD',
  LEGAL_AND_GENERAL = 'LEGAL_AND_GENERAL',
}

// NX-5231: DWP pension self-certification sets. Each set is an alternative
// "quality requirement" with its own statutory minimums.
export enum PensionSelfCertificationEnum {
  SET_1 = 'SET_1',
  SET_2 = 'SET_2',
  SET_3 = 'SET_3',
}

export type PensionContributionMins = { totalMin: number; erMin: number };

// Mirror of BE PENSION_SELF_CERT_MINS (payroll.enity.ts). Keep in sync.
export const PENSION_SELF_CERT_MINS: Record<
  PensionSelfCertificationEnum,
  PensionContributionMins
> = {
  [PensionSelfCertificationEnum.SET_1]: { totalMin: 9, erMin: 4 },
  [PensionSelfCertificationEnum.SET_2]: { totalMin: 8, erMin: 3 },
  [PensionSelfCertificationEnum.SET_3]: { totalMin: 7, erMin: 3 },
};

// No set certified — the pre-NX-5231 floors stay in force. Numerically equal
// to Set 2 but kept separate: an employer who certified nothing has not chosen
// Set 2, so the UI must not show Set 2 as selected on their behalf.
export const PENSION_UNCERTIFIED_MINS: PensionContributionMins = {
  totalMin: 8,
  erMin: 3,
};

// The floors in force for a given set, falling back to the uncertified ones.
// Every screen that takes contribution rates resolves them through here so the
// company setup wizard, the pension tab and the employee page cannot drift.
export const getPensionSelfCertMins = (
  set?: string | null,
): PensionContributionMins =>
  (set && PENSION_SELF_CERT_MINS[set as PensionSelfCertificationEnum]) ||
  PENSION_UNCERTIFIED_MINS;

// NX-5770: the set on one NEST frequency group. The settings are untyped and
// the set has been seen under either key name, so read both — reading one
// blanks the field, and a blank set silently means the uncertified 8% floor.
export const readNestSelfCertification = (frequencySettings: any): string =>
  frequencySettings?.selfCertification ||
  frequencySettings?.pensionSelfCertification ||
  '';

export const nowLikePensionProviders: string[] = [
  PensionProvidersNameEnum.NOW_PENSIONS,
  PensionProvidersNameEnum.AVIVA,
  PensionProvidersNameEnum.AEGON,
  PensionProvidersNameEnum.PEOPLES_PENSION,
  PensionProvidersNameEnum.ROYAL_LONDON,
  PensionProvidersNameEnum.SCOTTISH_WIDOWS,
  PensionProvidersNameEnum.JARVIS_PENSION,
  PensionProvidersNameEnum.STANDARD_LIFE,
  PensionProvidersNameEnum.PENFOLD,
  PensionProvidersNameEnum.LEGAL_AND_GENERAL,
];

export const isNowLikePensionProvider = (provider: string): boolean =>
  nowLikePensionProviders.includes(provider);

export enum NestConnectionStatusEnum {
  CONNECTED = 'CONNECTED',
  VALIDATING = 'VALIDATING',
  CONNECTING = 'CONNECTING',
  NOT_CONNECTED = 'NOT_CONNECTED',
  ERROR = 'ERROR',
}

export enum CompanyCreationMethodEnum {
  SEND_COMPANY_CREATION_LINK = 'SEND_COMPANY_CREATION_LINK',
  CREATE_COMPANY_MANUALLY = 'CREATE_COMPANY_MANUALLY',
}

export enum CompanyCreationTypeEnum {
  START_AT_BEGINNING = 'START_BEGINNING',
  START_PARTWAY = 'START_PARTWAY',
  CONTINUE_PARTWAY = 'CONTINUE_PARTWAY',
}

export enum DayOfWeekEnum {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}
